import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { hideLoading, showLoading } from 'react-redux-loading-bar'

import { actions as AuthActions, selectors as AuthSelectors } from '../../redux/auth/redux'
import { actions as AppActions } from '../../redux/app/redux'
import { selectors as TranslationSelectors } from '../../redux/i18n/redux'
import app from '../../config/app'
import routes, { Router } from '../../routes'
import ApiSagas from '../../redux/api/sagas'
import PaymentQueries from '../../graphql/query/Payment'
import AuthQueries from '../../graphql/query/Auth'

import { actions } from './redux'


export default class UserMySubscriptionSagas {

  static* init() {
    yield put(showLoading())
    const seo = yield call(UserMySubscriptionSagas.transformSeo)

    yield all([
      put(AppActions.setJsonld(null)),
      put(AppActions.setSeo(seo)),
      put(actions.setLoaded(true)),
      put(hideLoading()),
    ])

    return {}
  }

  static* revokeMandate() {
    yield put(showLoading())

    const user = yield select(AuthSelectors.user)
    const activeMandate = user?.company?.activeSepaMandate
    const result = yield call(ApiSagas.query, PaymentQueries.RevokeSepaMandate, { id: activeMandate?.id })

    if (result.errors) {
      yield put(actions.revokeMandateError(result.errors))
    } else {
      const res = yield call(ApiSagas.query, AuthQueries.me)

      if (!res.errors) {
        yield put(AuthActions.setUser(res.data.me))
        yield put(actions.revokeMandateSuccess(result.data.revokeMandate))
      }
    }

    yield put(hideLoading())
  }

  static* transformSeo() {
    const i18nLang = yield select(TranslationSelectors.lang)
    const i18nStore = yield select(TranslationSelectors.store)
    const companyTitleLabel = i18nStore[i18nLang].translation.SEO_candidate_notifications_title
    const companyDescriptionLabel = i18nStore[i18nLang].translation.SEO_company_my_subscription_description

    const seoProps = {
      title: companyTitleLabel,
      image: '',
      description: companyDescriptionLabel,
      url: `${app.APP_URL}${Router.getRouteUrl(routes.userMySubscription)}`,
      noindex: true,
    }

    return seoProps
  }

  static* loop() {
    yield all([
      takeLatest(actions.revokeMandate.getType(), UserMySubscriptionSagas.revokeMandate),
    ])
  }

}
